import { render, staticRenderFns } from "./bankcard.vue?vue&type=template&id=5189b9d3&scoped=true"
import script from "./bankcard.vue?vue&type=script&lang=js"
export * from "./bankcard.vue?vue&type=script&lang=js"
import style0 from "./bankcard.vue?vue&type=style&index=0&id=5189b9d3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189b9d3",
  null
  
)

export default component.exports